<template>
  <div id="ticket-timer" :class="color">
    <p>{{ timeLeft }}</p>
  </div>
</template>

<script>

export default {
  name: "ticket-timer",
  props: {
    datetime: {
      type: Date,
      required: true
    }
  },
  data() {
    return {
      timeLeft: '00:00:00',
      timer: null
    };
  },
  watch: {
    datetime() {
      clearInterval(this.timer);
      this.startCountdown();
    }
  },
  computed:{
    color(){
      if (this.timer && this.timeLeft === "00:00:00"){
          return 'ticket-timer-danger'
      }
      return 'ticket-timer-primary'
    }
  },
  methods: {
    startCountdown() {
      const oneDay      = 24 * 60 * 60 * 1000;
      const targetDate  = new Date(this.datetime.getTime() + oneDay);

      this.timer = setInterval(() => {
        const datetimeInSp = new Date().toLocaleString('en-US', {timeZone: 'America/Sao_Paulo', returnFormat: 'YYYY-MM-DDTHH:mm:ssZ'})
        const timeDiff = targetDate.getTime() - Date.parse(datetimeInSp);

        if (timeDiff <= 0) {
            clearInterval(this.timer);
            this.timeLeft = "00:00:00";
            return;
        }
        
        const totalSeconds  = Math.floor(timeDiff / 1000);
        const hours         = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
        const minutes       = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
        const seconds       = (totalSeconds % 60).toString().padStart(2, '0');
        this.timeLeft       = `${hours}:${minutes}:${seconds}`;
      }, 1000);
    }
  },
  mounted() {
    this.timeLeft = "00:00:00";
    this.startCountdown();
  },
  beforeDestroy() {
    this.timeLeft = "00:00:00";
    clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">

.ticket-timer-danger{
  color: rgba(var(--vs-danger), 1);
}
.ticket-timer-primary{
  color: rgba(var(--vs-primary), 1);
}

#ticket-timer {
  display: inline-block;
  width: 6.5em;
  font-size: 1em;
  text-align: center;
  padding: 0.85rem;
  border: solid 1px;
  border-radius: 0.5rem;
}

</style>